import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CURRENCY, NUMBER ,SELECT,DATE_DISABLE_NO_DAY,} = FIELD_TYPE;
  const listMonths = [];
  for (let month = 1; month <= 12; month++) {
    listMonths.push({
      value: month,
      label: `Tháng ${month}`,
    });
  }
  
  //--------------------------------------------------------
  const listYears = [];
  const currentYear = new Date().getFullYear();
  const startYear = 2020;
  const endYear = currentYear + 100;
  for (let year = startYear; year <= endYear; year++) {
    listYears.push({
      value: year,
      label: year.toString(),
    });
  }
  const listTT = [
    {value: 0, label: "Đã gia hạn"},
    {value: 1, label: "Đã xong"},
    {value: 2, label: "Đã đăng"},
    {value: 3, label: "Lên kế hoạch"},
  
  ];
  
  const dataFields: DataFormField[] = [
  
    {
      type: INPUT,
      label: "Mã đợt TD",
      name: "maDotTuyenDung",
      disable: true,
      rules: [{required: true, message: "Chưa nhập mã đợt tuyển dụng"}],
  
    },
    {
      type: INPUT,
      label: "Tên đợt TD",
      name: "tenDotTuyenDung",
      disable: false,
      rules: [{required: true, message: "Chưa nhập tên đợt tuyển dụng"}],
  
    },
    {
      type: INPUT,
      name: "soLuong",
      label: "Số lượng tuyển",
      disable: false,
      rules: [
      {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số"
      }],
    },
    {
      type: COMBO_BOX,
      name: "idPhongBan",
      label: "Phòng",
      disable: false,
      rules: [{required: true, message: "Chưa nhập phòng ban"}],
  
    },
    {
      type: COMBO_BOX,
  
      name: "namKehoach",
      label: "Năm kế hoạch",
      disable: false,
      options: listYears,
  
    },
    {
      type: COMBO_BOX,
  
      name: "idChucVu",
      label: "Chức vụ",
      disable: false,
      rules: [{required: true, message: "Chưa nhập chức vụ cho đợt tuyển dụng"}],
  
    },
    {
      type: COMBO_BOX,
  
      name: "diaBan",
      label: "Địa bàn",
      disable: false,
  
    },
    {
      type: DATE_DISABLE_NO_DAY,
      label: "Từ ngày",
      name: "tuyenDungTuNgay",
      expand: true,
      optionsTime: { showTime: false, format: FORMAT_TIME.dayFull },
      disableDate:false,
     // rules: [{validator: onChange1}],
    },
    {
      type: DATE_DISABLE_NO_DAY,
      label: "Đến ngày",
      name: "tuyenDungDenNgay",
      expand: true,
     // rules: [{validator: onChange}],
      optionsTime: { showTime: false, format: FORMAT_TIME.dayFull },
      disableDate:false,
    },
    {
      type: COMBO_BOX,
      name: "idTrangThai",
  
      label: "Trạng thái",
      options: listTT,
    },
    {
      type: CURRENCY,
  
      name: "mucLuongDeXuat",
      label: "Mức lương đề xuất",
      disable: false,
  
    },
    {
      type: CURRENCY,
  
      name: "chiPhiTuyenDung",
      label: "Chi phí tuyển dụng",
      disable: false,
  
    },
    {
      type: INPUT,
  
      name: "noiDung",
      label: "Nội dung",
      disable: false,
  
    },
    {
      type: INPUT,
  
      name: "moTa",
      label: "Mô tả",
      disable: false,
      // css: {
      //   xl: 16,
      //   lg: 12,
      //   md: 24,
      //   sm: 24,
      //   xs: 24,
      // },
      // labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
      // wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
  
    },
  
  
  ];
export { dataFields };

